export const STEPPER_SECTIONS = [
  'stepper.memberIdentityConfirmation',
  'stepper.addressConfirmation',
  'stepper.acceptTerms',
];
